import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { Terminal } from '~/types';
import { cleanupFormValues } from '~/utils';
import TerminalForm from './TerminalForm';
import { terminals } from '~/routes';
import { FormDrawer } from '~/components';
import { usePermissions } from '~/hooks';
import { useTerminalsEdit } from '~/hooks/terminals';

interface TerminalEditProps {
  initialValues: Terminal;
}

const TerminalEdit: FC<TerminalEditProps> = (props) => {
  const { initialValues } = props;
  const [t] = useTranslation('terminals');
  const dt = (key: string): string => t(`translation:${key}`);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { mutate, isLoading } = useTerminalsEdit();

  const onFinish = (values: Terminal) => {
    mutate({
      id: initialValues.id as string,
      body: cleanupFormValues({ ...initialValues, ...values }),
    });
    handleClose();
  };

  const hasAccessUpdate = usePermissions('business.terminal.update');
  if (!hasAccessUpdate) return null;
  return (
    <>
      <Button onClick={handleOpen} type="primary">
        {dt('edit')}
      </Button>
      <FormDrawer
        name={terminals}
        onFinish={onFinish}
        loading={isLoading}
        title={t('editTerminal')}
        onClose={handleClose}
        visible={open}
      >
        <TerminalForm name={terminals} initialValues={initialValues} edit />
      </FormDrawer>
    </>
  );
};

export default TerminalEdit;
